import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoReanudacionCATA = {
  status: number | null;
  statusText: string | null;
};

const useGetInfoReanudacionCATA = () => {
  const [loadingGetInfoReanudacionCATA, setLoadingGetInfoReanudacionCATA] = useState(false);
  const [successGetInfoReanudacionCATA, setSuccessGetInfoReanudacionCATA] = useState(false);
  const [errorGetInfoReanudacionCATA, setErrorGetInfoReanudacionCATA] = useState<any>(null);
  const [dataGetInfoReanudacionCATA, setDataGetInfoReanudacionCATA] = useState<any>(null);

  const [statusGetInfoReanudacionCATA, setStatusGetInfoReanudacionCATA] =
    useState<StatusGetInfoReanudacionCATA>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoReanudacionCATA = async (
    userId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoReanudacionCATA(true);
    setSuccessGetInfoReanudacionCATA(false);
    setErrorGetInfoReanudacionCATA(null);

    try {
      const res = await apiRecord.getInfoSolicitudReanudacion(userId);

      setStatusGetInfoReanudacionCATA({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetInfoReanudacionCATA(true);
      setDataGetInfoReanudacionCATA(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetInfoReanudacionCATA({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetInfoReanudacionCATA(err);
      console.error("Error en getInfoReanudacionCATA:", err);

      throw err;

    } finally {
      setLoadingGetInfoReanudacionCATA(false);
    }
  };

  return {
    getInfoReanudacionCATA,
    loadingGetInfoReanudacionCATA,
    successGetInfoReanudacionCATA,
    errorGetInfoReanudacionCATA,
    dataGetInfoReanudacionCATA,
    statusGetInfoReanudacionCATA
  };
};

export default useGetInfoReanudacionCATA;
